@if (configuration) {
  <section
    class="authentication__splash"
    [ngStyle]="{ 'background-image': 'url(' + configuration.splash + ')' }"
  >
    <div class="container">
      <div class="u-flex u-justifyEnd">
        <card class="authentication__card">
          <h4 title class="t-bold">
            {{ configuration.form.title }}
          </h4>
          <section body>
            <form-group
              [configs]="configuration.form.controls"
              [form]="form"
              (keyup.enter)="login()"
            >
            </form-group>
          </section>
          <footer footer>
            <zip-button
              [config]="configuration.form.submit"
              [disabled]="isLoggingIn"
              (zipButtonClicked)="login()"
            >
            </zip-button>
          </footer>
        </card>
      </div>
    </div>
  </section>
  @if (configuration.content) {
    <div class="container">
      <section class="authentication__section">
        <header class="authentication__section__header">
          <icon
            [name]="configuration.content.icon"
            [config]="{
              set: 'product',
              size: 'large',
              fill: 'primary',
            }"
          >
          </icon>
          <h4 class="t-bold">{{ configuration.content.title }}</h4>
          <p class="t-data">{{ configuration.content.subtitle }}</p>
        </header>
        <section class="authentication__section__columns">
          @for (column of configuration.content.columns; track column) {
            <div class="authentication__section__column">
              <header class="authentication__section__column__header">
                <h4 class="t-bold">{{ column.label }}</h4>
              </header>
              @if (column.description) {
                <p class="t-data">{{ column.description }}</p>
              }
              @if (column.checklist) {
                <ul class="authentication__section__column__list">
                  @for (item of column.checklist; track item) {
                    <li class="authentication__section__column__list__item">
                      <icon name="check"></icon>
                      <p class="t-data">{{ item }}</p>
                    </li>
                  }
                </ul>
              }
              @if (column.links) {
                <ul class="authentication__section__column__list">
                  @for (link of column.links; track link) {
                    <li class="authentication__section__column__list__item">
                      <p class="t-data t-link">{{ link.label }}</p>
                      <icon name="chevron_right" [config]="{ type: 'link' }">
                      </icon>
                    </li>
                  }
                </ul>
              }
              <div class="authentication__action__buttons">
                @if (column.button) {
                  <zip-button [config]="column.button"> </zip-button>
                }
              </div>
            </div>
          }
        </section>
      </section>
    </div>
  }
}
